<div class="light-table requested-users-table">
  <app-user-list-header
    class="light-table-header"
    #userListHeader
    (checkboxChange)="toggleInviteAll($event)"
    [isLoading]="(isLoading$ | async) || loadingCollection"
    [suggestInsteadDirectAccept]="suggestInsteadDirectAccept"
    [jobInPast]="jobInPast"></app-user-list-header>
  <div
    class="noUser light-table-list-item"
    *ngIf="
      collection?.length == 0 && !(isLoading$ | async) && !loadingCollection
    ">
    {{ ("noUsersFound" | i18n) || "No users found" }}
  </div>
  <ng-container
    *ngFor="let poolerUser of collection; trackBy: trackUser; let i = index">
    <app-possible-user-list-item
      class="light-table-list-item light-table-interactable-item"
      #userListItem
      [directAcceptChecked]="directAcceptedUserIds.includes(poolerUser._id)"
      [directInviteChecked]="directInvitedUserIds.includes(poolerUser._id)"
      [user]="poolerUser"
      [job]="job"
      [jobCustomer]="jobCustomer"
      [loggedInCustomer]="loggedInCustomer"
      [jobDate]="jobDate"
      [randomId]="randomId"
      [jobCount]="jobCount"
      [userCount]="userCount"
      [jobInPast]="jobInPast"
      (inviteeToggled)="
        inviteeToggled.next($event)
      "></app-possible-user-list-item>
  </ng-container>
</div>
